// @ts-nocheck
// fetch all notifications...
export const GET_ALL_NOTIFICATIONS_REQUEST = "GET_ALL_NOTIFICATIONS_REQUEST";
export const GET_ALL_NOTIFICATIONS_SUCCESS = "GET_ALL_NOTIFICATIONS_SUCCESS";
export const GET_ALL_NOTIFICATIONS_FAILURE = "GET_ALL_NOTIFICATIONS_FAILURE";
// fetch all notifications...

// unread notifications count...
export const SET_UNREAD_NOTIFICATIONS_COUNT = "SET_UNREAD_NOTIFICATIONS_COUNT"; 
// unread notifications count...

//getOneOnOneNotesOfAssignee (create note notification)
export const NEW_TRIGGER_NOTE_NOTIFICATION = "NEW_TRIGGER_NOTE_NOTIFICATION";
export const FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_REQUEST = "FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_REQUEST";
export const FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_SUCCESS = "FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_SUCCESS";
export const FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_FAILURE = "FETCH_ONE_ON_ONE_NOTES_OF_ASSIGNEE_FAILURE";